import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import type { AxiosProgressEvent } from 'axios';
import { ApiService } from 'src/data/services/Services';
import type { ApiGallery } from 'src/core/models/api/ApiGallery';

const initialState: {
	allGalleries: ApiGallery[];
	isLoading: boolean;
} = {
	allGalleries: [],
	isLoading: false,
};

export const useGalleryStore = create(
	combine(initialState, (set) => ({
		fetchGalleries: async (eventUuids: string, silent = false) => {
			if (!silent) {
				set({ isLoading: true });
			}
			try {
				const { data } = await ApiService.endpoints.galleries.eventGalleries({ eventUuids });
				const galleryData = data.filter((gallery) => (Number(gallery.total_photos) || 0) > 0);
				set(silent ? { allGalleries: galleryData } : { allGalleries: galleryData, isLoading: false });
			} catch (error) {
				console.error('Error fetching galleries:', error);
				if (!silent) {
					set({ isLoading: false });
				}
			}
		},

		// Uploads a single photo to a gallery.
		uploadPhoto: async ({
			eventUuid,
			galleryId,
			payload,
			onUploadProgress,
		}: {
			eventUuid: string;
			galleryId: string | number;
			payload: Record<string, unknown>;
			onUploadProgress?: (event: AxiosProgressEvent) => void;
		}) => {
			const { data } = await ApiService.endpoints.galleries.upload({ eventUuid, galleryId, payload, onUploadProgress });
			return data;
		},
	})),
);
